import {Component, inject} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {ButtonModule} from "primeng/button";
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {UpperCasePipe} from "@angular/common";
import {InputTextModule} from "primeng/inputtext";

@Component({
  selector: 'app-config-identification-popup',
    imports: [
        InputTextModule,
        TranslatePipe,
        ButtonModule,
        ReactiveFormsModule,
        UpperCasePipe,
    ],
  templateUrl: './config-identification-popup.component.html',
  styleUrl: './config-identification-popup.component.scss'
})
export class IdentificationPopup {
    private readonly dialogRef = inject(DynamicDialogRef)

    form = new FormGroup({
        identification: new FormControl('', { nonNullable: true, validators: [Validators.required] })
    });

    onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }
        this.dialogRef.close(this.form.controls.identification.value);
    }
}
